import React from 'react'
import i18next from 'i18next'
import { Button, Form, Alert, ProgressBar } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import hash from 'object-hash'
import FileDropzone from 'src/components/system_wide/file_dropzone'
import SelectBrandModal from 'src/components/system_wide/select_brand_modal'
import SelectAgentsModal from '../system_wide/select_agents_modal'
import { filesize } from 'filesize'
import { success, error } from 'src/components/system_wide/notification'
import cloneDeep from 'lodash.clonedeep'
import axios from 'src/lib/axios'

const { t } = i18next

const SUPPORTED_MIMETYPE = [
  'application/zip',
  'application/x-zip-compressed',
  'text/plain',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/msword',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf',
  'image/jpeg',
  'image/png',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
]
const MAX_FILE_SIZE = 47.68 * 1024 * 1024
class DocumentForm extends React.Component {
  static defaultProps = {
    onSave: () => {},
    closeForm: () => {},
    roles: [],
    users: [],
    brands: [],
  }

  state = {
    id: null,
    description: '',
    showDragzone: true,
    dimmed: false,
    msg: '',
    files: [],
    selected_users: [],
    selected_brands: [],

    hash_document: '',
  }

  initialHash = ''
  selectAgentsModalRef = null
  constructor(props) {
    super(props)
    this.selectAgentsModalRef = React.createRef()
    if (props.document) {
      this.state.id = props.document.id
      this.state.description = props.document.description
      this.state.selected_users = props.document.selected_users
      this.state.selected_brands = props.document.selected_brands
    }

    // eslint-disable-next-line no-unused-vars
    let { hash_document, ...rest } = this.state
    this.initialHash = hash(rest)
  }
  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { hash_document, ...rest } = this.state
    this.setState({ hash_document: hash(rest) })
  }
  componentWillUnmount() {}

  handleDismiss = () => {
    this.setState({
      id: null,
      dimmed: false,
      files: [],
      msg: '',
      showDragzone: true,
      selected_users: [],
      selected_brands: [],
    })
  }

  handleDrop = documents => {
    let files = cloneDeep(this.state.files)
    for (let file of Object.values(documents)) {
      let unsupported = !SUPPORTED_MIMETYPE.includes(file.type)
      files.push({ data: file, unsupported })
    }
    this.setState({ files, msg: '' }, () => this.updateHash())
  }

  onConfirmUpload = async () => {
    let { id, description, selected_users, selected_brands } = this.state
    if (id === null) {
      let files = this.state.files.filter(f => !f.unsupported).map(f => f.data)
      if (files.length === 0) {
        this.setState({ msg: 'Nessun file valido presente' })
        return
      }
      const formData = new FormData()
      for (let file of files) {
        formData.append('files[]', file)
      }

      for (let key in selected_users) {
        formData.append('selected_users[]', selected_users[key])
      }
      for (let key in selected_brands) {
        formData.append('selected_brands[]', selected_brands[key])
      }
      formData.append('description', description)
      this.setState({ dimmed: true })
      try {
        await axios.post('/api/document', formData, { onUploadProgress: this.onUploadProgress })
        this.onRestoreSuccess()
      } catch (error) {
        if (error.response.status === 413) {
          this.setState({ msg: 'I file caricati superano il limite consentito' })
        }
        this.onRestoreError()
      }
    } else {
      await this.props.onSave({
        id,
        description,
        selected_users,
        selected_brands,
      })
      this.handleDismiss()
    }
  }

  onUploadProgress = progressEvent => {
    let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    this.setState({ progress })
  }

  onRestoreError = () => {
    error(t('components.document.upload_error', 'Impossibile caricare i documenti'))
    this.setState({
      id: null,
      dimmed: false,
      showDragzone: true,
    })
  }

  onRestoreSuccess = () => {
    success(t('components.document.upload_success', 'Documenti caricati con successo'))
    this.handleDismiss()
    this.props.closeForm()
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleDescriptionChange = ({ target: { value } }) => {
    this.setState({ description: value }, () => this.updateHash())
  }

  handleChangeUser = users => {
    this.setState({ selected_users: users.map(u => u.id) }, () => this.updateHash())
  }

  handleChangeBrand = brands => {
    this.setState({ selected_brands: brands }, () => this.updateHash())
  }
  handleRemoveFile = index => () => {
    let { files } = this.state
    files.splice(index, 1)
    this.setState({ files, msg: '' }, () => this.updateHash())
  }

  isFormValid = () => {
    let { id, files, selected_users } = this.state
    let total_size = files.reduce((acc, f) => acc + f.data.size, 0)
    return (
      (files.length > 0 || id !== null) &&
      selected_users?.length > 0 &&
      files.some(f => !f.unsupported) &&
      total_size < MAX_FILE_SIZE
    )
  }

  render() {
    let { id, msg, selected_users, selected_brands, description, showDragzone, files, dimmed, progress } = this.state
    let total_size = files.reduce((acc, f) => acc + f.data.size, 0)
    return (
      <>
        <div className="flex-fill position-relative overflow-auto" style={{ minHeight: '40vh' }}>
          <div className="container">
            <Form.Label>
              <Trans i18nKey="components.users.users">Utenti</Trans>
              <span> *</span>
            </Form.Label>
            <div className="d-flex flex-row align-items-center text-muted">
              <span>
                <b>{selected_users.length}</b> <Trans i18nKey="components.users.selected">selezionati</Trans>
              </span>
              <Button className="ms-2" onClick={() => this.selectAgentsModalRef.current.show({ selected_users })}>
                <i className="fas fa-plus fa-fw text-start me-0"></i>
                {selected_users.length > 0 && <Trans i18nKey="components.users.edit_brand">Modifica</Trans>}
                {selected_users.length === 0 && <Trans i18nKey="components.users.add_brand">Aggiungi</Trans>}
              </Button>
            </div>
            {/* <SelectUserModal selected={selected_users} onChange={this.handleChangeUser} /> */}
            <SelectBrandModal selected={selected_brands} onChange={this.handleChangeBrand} />
            <Form.Group className="mb-4">
              <Form.Label>
                <Trans i18nKey="documents.description">Descrizione</Trans>
              </Form.Label>
              <Form.Control
                name="description"
                placeholder={t('documents.description', 'Descrizione')}
                value={description}
                onChange={this.handleChange}
                disabled={id !== null}
              />
            </Form.Group>
            <Form.Group className="mt-3">
              <div style={{ position: 'relative', display: 'block' }}>
                {showDragzone === false && (
                  <>
                    <Alert className="mt-3" onClose={this.handleDismiss} dismissible>
                      <Alert.Heading>
                        <Trans i18nKey="system_wide.bulk_import.file_check_completed">File check completed</Trans>
                      </Alert.Heading>
                      <div className="mt-3 text-end gap-2"></div>
                    </Alert>
                  </>
                )}

                {id === null && showDragzone === true && (
                  <>
                    <FileDropzone dimmed={dimmed} onDrop={this.handleDrop} accept={[]} multiple={true} />
                    {dimmed === true && <ProgressBar animated now={progress} />}
                    <b>
                      {t('documents.upload_max_size', 'Dimensione massima: {{max}}', {
                        max: filesize(MAX_FILE_SIZE),
                      })}
                    </b>
                    <ProgressBar
                      className="mb-3"
                      animated
                      now={total_size}
                      max={MAX_FILE_SIZE}
                      label={`${((total_size * 100) / MAX_FILE_SIZE).toFixed(2)}%`}
                      variant={total_size > MAX_FILE_SIZE ? 'danger' : 'info'}
                    />
                    {files.map((f, i) => {
                      return (
                        <div key={i} className="d-flex flex-row align-items-center  mb-1">
                          <i className="fas fa-file" /> {f.data.name} ({filesize(f.data.size)})
                          {f.unsupported === true && <span className="ms-1 text-danger">(formato non supportato)</span>}
                          <i
                            className="fa fa-trash mt-1 ms-auto text-danger"
                            onClick={this.handleRemoveFile(i)}
                            style={{ cursor: 'pointer' }}></i>
                        </div>
                      )
                    })}
                    {msg !== '' && <div className="text-center text-danger">{msg}</div>}
                  </>
                )}
              </div>
            </Form.Group>
          </div>
        </div>
        <div className="border-top pt-2">
          <Button
            className="float-end"
            variant="primary"
            disabled={!this.isFormValid() || this.initialHash === this.state.document_hash}
            onClick={this.onConfirmUpload}>
            <Trans i18nKey="buttons.confirm">Conferma</Trans>
          </Button>
          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={this.props.users}
          brands={this.props.brands}
          roles={this.props.roles}
          onChange={this.handleChangeUser}
          multiSelection={true}
        />
      </>
    )
  }
}
export default DocumentForm
